<!--
 - Author : wanghongling.
 - Date   : 2020/4/2.
 - File   : temperature.首页-体温异常人员模块
 -->

<template>
  <div class="temperature jKzdq-personal">
    <layer
        title="体温异常人员"
        width="418px"
        padding="10px 20px 5px"
        contPadding="5px 0 0"
        :showMoreTag="list.length>1"
        @showMore="showMore">
      <div class="tem-tips" v-if="list && list.length>0">体温异常人员，请立即安排休假，不得上岗！</div>
      <el-carousel :interval="5000" :indicator-position="list.length>1?'outside':'none'"
          :arrow="list.length>1?'hover':'never'">
        <el-carousel-item v-for="(item, index) in list" :key="index">
          <div :class="['person-list', item.length>1?'':'jsc']">
            <div class="person-list-item" v-for="(person, i) in item" :key="i">
              <div class="person-list-item-left">
                <img :src="person.fileId?`${imgUrl}${person.fileId}`:avatar" alt="">
              </div>
              <div class="person-list-item-right">
                <p>
                  <el-tooltip effect="light" :content="person.userName"
                      placement="bottom">
                    <span class="name">{{person.userName|filterName}}</span>
                  </el-tooltip>
                  <span class="res">({{person.departmentName}})</span>
                </p>
                <p class="temp-num">{{person.bodyTeperature}}℃</p>
                <p class="">{{person.teperatureTime}}打卡</p>
              </div>
            </div>
          </div>
        </el-carousel-item>
        <div class="no-the-data" v-if="list && list.length===0">
          <div>
            <i class="iconfont icon-content-likes dzi"></i>
            <p>所有人员体温正常</p>
          </div>
        </div>
      </el-carousel>
      <transition name="slide-right-fade">
        <people-List class="per-pop" :peopleObj="peopleObj" v-show="peopleObj.isMore"></people-List>
      </transition>
    </layer>
  </div>
</template>

<script>
  export default {
    name: 'temperature',
    data () {
      return {
        orgId: this.$store.getters.userInfo.orgId,
        imgUrl: this.$store.getters.fileApi,
        avatar: require('../../assets/images/avatar.jpg'),
        list: [],
        peopleObj: {
          title: '体温异常人员',
          isMore: false,
          list: []
        }
      }
    },
    props: {
      selectOrgId: {}
    },
    watch: {
      selectOrgId: {
        handler(cur) {
          this.orgId = cur
          this.getExceptionTemperature()
        },
        deep: true
      }
    },
    mounted() {
      this.orgId = this.$store.getters.userInfo.orgId
      this.getExceptionTemperature()
      this.onWebsocketMsg()
    },
    methods: {
      /**
       * @Description:显示更多体温异常人员列表弹窗
       * @author wanghongling
       * @createDate 2020/4/3
      */
      showMore() {
        this.peopleObj.isMore = !this.peopleObj.isMore
      },
      /**
       * @Description:获取体温异常人员
       * @author wanghongling
       * @createDate 2020/4/26
      */
      getExceptionTemperature() {
        this.$request.pcHealthWholeviewExceptionTemperature({orgId: this.orgId}).then(res => {
          console.log('获取体温异常人员', res)
          if (!this.$utils.isEmptyObject(res)) {
            this.peopleObj.list = res
            this.list.length = 0
            let tmpList = res
            for (let i = 0; i < tmpList.length; i += 4) {
              this.list.push(tmpList.slice(i, i + 4))
            }
          } else {
            this.list = []
          }
        }).catch(e => {
          console.error(e)
        })
      },
      /**
       * @author wanghongling
       * @createTime 2020/04/27
       * @description websocket监听数据
       */
      onWebsocketMsg () {
        window.getTemp = e => {
          console.log(e, 'websocket监听数据')
          this.getExceptionTemperature()
        }
      }
    }
  }
</script>

<style lang="less" rel="stylesheet/less">
  .temperature{

    .el-carousel__container{
      height: 170px !important;
    }
    .el-carousel__indicators--horizontal{
      margin-top: -20px;
    }
    .dzi{
      font-size: 40px !important;
    }
    .temp-num{
      color: #ffc600 !important;
      padding-top: 2px;
    }
    .tem-tips{
      color: #ff5a00;
      font-size: 15px;
      text-align: center;
      padding: 5px 0;
    }
    .per-pop{
      position: absolute;
      right: 430px;
      top: 0;
      z-index: 2;
      .detail-wrap{
        max-height: 300px !important;
      }
    }
    .layer-wrap{
      position: relative;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/index/temperature.vue